import { Typography } from "@mui/material";

export default function NotFound() {
    return (
        <Typography variant="h1" textAlign="center" mt={12}>
            404 Page not found
        </Typography>
    );
}